import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import tooltipIcon from "../../../../../../images/icon_tooltip/icon_tooltip_24x24.svg";

const CustomTooltip = ({ title, icon }) => (
  <Tooltip
    title={<p style={{ fontSize: "12px", width: "160px" }}>{title}</p>}
    placement="bottom-start"
  >
    <IconButton sx={{ padding: 0 }}>
      {icon ? (
        <img src={icon} alt="tooltipIcon" />
      ) : (
        <img src={tooltipIcon} alt="tooltipIcon" />
      )}
    </IconButton>
  </Tooltip>
);

export default CustomTooltip;

CustomTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};
